import React from 'react';
import classnames from 'classnames';

import { IMAGE_SIZES } from '@buyside/components/presentation/ProfileImage/profileImage';

import styles from './profileImageStyles.scss';

const ProfileImageLoading: React.FC<{
  className?: string;
  size?: string;
}> = ({ className, size = IMAGE_SIZES.MEDIUM }) => (
  <span
    className={classnames(styles.skeleton, styles[`image-${size}`], styles.circle, className)}
  />
);

export default ProfileImageLoading;
